import React, { FC, useEffect } from 'react';
import s from './index.module.scss';
import Checkout from './checkout';
import locales from '../../../../../content.json';

declare global {
  interface Window {
    paymentRequestApplePayValue: boolean;
    paymentApplePay: boolean;
  }
}

const PaymentModalV3 : FC = () => {

  useEffect(() => {
    window.paymentRequestApplePayValue = true;
    window.paymentApplePay = true;
  }, []);

  return(
    <div className={s.wrapper} id="paymentModal">
      <h3 className={s.title}>
        {locales[window.userLang].payment_text_88}
      </h3>
      <Checkout />
    </div>
  )

}

export default PaymentModalV3;